import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Reject values that are non-empty but become empty after trimming
 * (i.e. " ", "  ", "\t\n"). Pairs with the `trimOnBlur` directive
 * which strips surrounding whitespace as the user leaves the field;
 * this validator catches the in-between state where the only content
 * is whitespace.
 *
 * Cooperates with — does not duplicate — `Validators.required`:
 *   - empty string → null (let `required` handle it)
 *   - whitespace-only → `{ nonBlank: true }`
 *   - non-blank → null
 *
 * Internal whitespace between words is intentionally preserved
 * (e.g. "Acme  Corp" is valid). Only fully-blank values are rejected.
 */
export const nonBlankValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const raw = control.value;
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  if (typeof raw !== 'string') {
    return null;
  }
  if (raw.trim() === '') {
    return { nonBlank: true };
  }
  return null;
};
